import app from 'flarum/forum/app';
import ResourceMapPage from './ResourceMapPage';
app.initializers.add('voucha-resourcemap', () => {
  // Voucha Atlas, its item pages, and the old address
  app.routes['voucha-resourcemap'] = {
    path: '/atlas',
    component: ResourceMapPage
  };
  app.routes['voucha-resourcemap.item'] = {
    path: '/atlas/:item',
    component: ResourceMapPage
  };
  app.routes['voucha-resourcemap.plan'] = {
    path: '/atlas/plan/:plan',
    component: ResourceMapPage
  };
  app.routes['voucha-resourcemap.old'] = {
    path: '/resource-map',
    component: ResourceMapPage
  };
});